<template>
  <div class="location-plan-list-bd" v-if="funcView.location_plan_list">
    <div class="search-hd clear">
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
        </el-form-item>
        <el-form-item style="float: right" v-if="funcView.location_plan_export">
          <el-button type="info" @click="onExport">
            <i class="icon icon-export-excel"></i>
            {{ $t('Common.com_export') }} Excel
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('plan.ji_hua_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
      <div class="query-filter" v-show="isFilter">
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_location_name') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.locationName" clearable @input="onPageChange({ page: 1 })" style="width: 100%"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('plan.xmssgs') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.orgName" clearable @input="onPageChange({ page: 1 })" style="width: 100%"></el-input>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              v-if="formSearch.orgName"
              closable
              @close="
                formSearch.orgName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.orgName }}
            </el-tag>
            <el-tag
              v-if="formSearch.locationName"
              closable
              @close="
                formSearch.locationName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.locationName }}
            </el-tag>
            <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="border-radius: 16px; margin-top: 16px; padding: 24px 24px 0; background: #fff">
      <div class="table-bd">
        <custom-table
          index
          tableCode="portal_location_plan"
          :stripe="true"
          @column="setColumn"
          height="100%"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['scheduleCondition', 'action']"
        >
          <template v-slot:scheduleCondition="scope">
            <span v-if="scope.row.scheduleMethod == 2 && scope.row.scheduleCondition.split(',').length != 7">
              {{
                scope.row.scheduleCondition
                  .replace('1', $t('plan.xing_qi_yi'))
                  .replace('2', $t('plan.xing_qi_er'))
                  .replace('3', $t('plan.xing_qi_san'))
                  .replace('4', $t('plan.xing_qi_si'))
                  .replace('5', $t('plan.xing_qi_wu'))
                  .replace('6', $t('plan.xing_qi_liu'))
                  .replace('7', $t('plan.xing_qi_ri'))
              }}
            </span>
            <span v-if="scope.row.scheduleMethod == 2 && scope.row.scheduleCondition.split(',').length == 7">{{ $t('plan.mei_ri_gong_zuo') }}</span>
            <span v-if="scope.row.scheduleMethod == 3 && scope.row.scheduleCondition != ''">{{ $t('plan.mei_yue') }}{{ scope.row.scheduleCondition }}{{ $t('plan.ri_xiu_xi') }}</span>
            <span v-if="scope.row.scheduleMethod == 3 && scope.row.scheduleCondition == ''">{{ $t('plan.mei_ri_gong_zuo') }}</span>
          </template>
          <template v-slot:action="scope">
            <el-button type="text" size="mini" v-if="funcView.location_plan_edit" @click.stop="editPlan(scope.row)">{{ $t('Common.com_edit') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_plan_delete" @click.stop="deletePlan(scope.row)">{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-footer">
        <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
    <location-plan-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></location-plan-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import locationPlanDialog from './children/location_plan_dialog.vue';

// i18n-lang-component
export default {
  name: 'locationPlan',
  components: { locationPlanDialog },
  data() {
    return {
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,
        locationName: '',
        orgName: '',
      },

      isFilter: false,
      tableList: [],
      totalRows: null,
      // 区域
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted: function () {
    this.getFuncView('/other/location');
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.locationSchedulePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    editPlan(row) {
      this.dialogVisible = true;
      this.dialogModel = {
        type: 'edit',
        title: this.$t('plan.bian_ji_ji_huao', [row.locationName]),
        data: { ...row },
      };
    },
    deletePlan(row) {
      this.$showConfirm(this, this.$t('plan.nqdyscgjhm'))
        .then(() => {
          this.$postJSON(`${apis.locationScheduleDelete}/${row.locationScheduleId}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getTableList();
            }
          });
        })
        .catch(() => {});
    },
    onClear() {
      this.formSearch.orgName = '';
      this.formSearch.locationName = '';
      this.onPageChange({ page: 1 });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 导出
    onExport: function () {
      this.exportTable('locationPlanExport', this.formSearch);
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.location-plan-list-bd {
  .el-radio-button:first-child .el-radio-button__inner {
    border-radius: 20px 0 0 20px;
  }

  .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 20px 20px 0;
  }
  .search-hd {
    padding: 24px;
    // height: 90px;
    /* 字体色/#FFFFFF */
    background: #ffffff;
    border-radius: 16px;
    .title-hd {
      font-weight: bold;
      font-size: 18px;
      line-height: 40px;
      margin-bottom: 24px;
      /* 字体色/$--color-text-primary */
      color: $--color-text-primary;
      .icon {
        font-size: 20px;
        color: $--color-text-primary;
        margin-right: 12px;
      }
    }
    .form-screen {
      // min-height: 40px;
      // display: flex;
      // align-items: flex-start;
      .el-form-item {
        margin-bottom: 0;
      }
      .tag-item {
        flex: 1;
        width: 0;
        .el-form-item__content {
          width: 100%;
        }
        .item-tag {
          // height: 40px;
          line-height: 40px;
          display: flex;
          align-items: flex-start;

          // max-width: 520px;
          // overflow: auto;
          .lable {
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            line-height: 140%;
            color: $--color-text-secondary;
            margin-right: 8px;
            margin-top: 8px;
          }
          .tag-list {
            display: flex;
            flex-direction: row;
            // align-items: center;
            flex: 1;
            flex-wrap: wrap;
            // overflow-x: auto;
            margin-right: 8px;
            .tag {
              height: 30px;
              color: #1a1a1a;
              background: #f8f8f8;
              padding: 0 16px;
              background: #f8f8f8;
              line-height: 30px;
              margin-right: 8px;
              margin-bottom: 8px;
              border-radius: 100px;
              cursor: pointer;
              flex: none;
              .name {
                margin-right: 4px;
              }
              .icon {
                font-size: 12px;
                color: $--color-primary;
                margin-left: 11px;
              }

              &.active {
                color: #ffffff;
                background: $--color-primary;
              }
            }
          }

          .icon-shezhi,
          .icon-guanbi1,
          .icon-tianjia {
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: $--color-text-primary;
            border-radius: 100px;
            background-color: $--color-warning;
            margin-right: 8px;
            cursor: pointer;
          }
          .icon-tianjia {
            color: $--color-primary;
            background-color: #f8f8f8;
          }
        }
      }
      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 14px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }
  }

  // 表格
  .table-bd {
    height: 450px;
  }
  .table-footer {
    margin-top: 16px;
  }
}
</style>
